import { render } from "./VideoElement.vue?vue&type=template&id=41ec46a6&scoped=true&ts=true"
import script from "./VideoElement.vue?vue&type=script&lang=ts"
export * from "./VideoElement.vue?vue&type=script&lang=ts"

import "./VideoElement.vue?vue&type=style&index=0&id=41ec46a6&lang=scss&scoped=true"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ec46a6"]])

export default __exports__